<template>
  <div class="home">
    <!-- <f-notification v-html="$t('notification.data-lost')"/> -->

    <f-introduction />

    <f-gatekeeper-survey />

    <f-wordcloud />
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
import introduction from "@/components/Other/Introduction.vue";
import gatekeeperSurvey from "@/components/Other/GatekeeperSurvey.vue";
import wordcloud from "@/components/Other/Wordcloud.vue";
// import notification from "@/components/Globals/Notification.vue";

export default {
  name: "home",
  components: {
    "f-introduction": introduction,
    "f-gatekeeper-survey": gatekeeperSurvey,
    "f-wordcloud": wordcloud,
    // "f-notification": notification,
  },
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
.home {
  @include max-medium {
    margin-bottom: $margin-bottom-mobile;
  }

  @include min-large {
    margin-bottom: $margin-bottom-desktop;
  }
}
</style>
